import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { useSelectedOrganization } from '../../organization/hooks/useSelectedOrganization';
import { GET_CREDIT_PACKS_QUERY_KEY } from './useListCreditPacks';

export const useDeleteCreditPack = () => {
  const client = useApiClient();
  const queryClient = useQueryClient();
  const { selectedOrganization } = useSelectedOrganization();

  return useMutation({
    mutationFn: (packId: string) =>
      client.fetchApi<{ success: boolean }, {}>({
        endpoint: `wallet/admin/credit-packs/${packId}`,
        method: 'DELETE',
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: GET_CREDIT_PACKS_QUERY_KEY(selectedOrganization?.id || ''),
      });
    },
  });
};
